<template>
  <div class="position-fixed bottom-0 end-0 p-3" style="z-index: 11">
    <div id="liveToast" class="toast" role="alert" aria-live="assertive" aria-atomic="true">
      <div class="toast-header">
        <strong class="me-auto">淨碳點餐平台提醒</strong>
        <button type="button" class="btn-close" data-bs-dismiss="toast" aria-label="Close"></button>
      </div>
      <div class="toast-body" v-html="Content"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Toast",
  props: {
    Content: String
  },
}
</script>

<style>

</style>